"use client";

import posthog from "posthog-js";

// ─────────────────────────────────────────────────────────────────────────────
// lib/analytics.ts — the ONLY file importing posthog-js (§16 one-file rule).
// Client-side. INERT without NEXT_PUBLIC_POSTHOG_KEY. Demos carry NO tracking
// (private toys) — we skip init on demo hosts (<slug>.demo.<apex> / legacy
// demo-<slug>.<apex>). Live sites + the funnel are tracked. Funnel events:
// landing → picker → form → OTP → demo → buy → paid.
// ─────────────────────────────────────────────────────────────────────────────

let started = false;

function isDemoHost(hostname: string): boolean {
  const apex = process.env.NEXT_PUBLIC_APEX ?? "makemysitetoday.com";
  return (
    hostname.startsWith("demo-") || // legacy demo-<slug>.<apex>
    hostname.endsWith(`.demo.${apex}`) ||
    hostname.endsWith(`.dev.demo.${apex}`)
  );
}

export function initAnalytics(): void {
  if (started || typeof window === "undefined") return;
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!key) return; // inert until a dedicated PostHog project key is set
  if (isDemoHost(window.location.hostname)) return; // demos = no tracking (§16)
  posthog.init(key, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com",
    capture_pageview: false, // captured manually on route change
    person_profiles: "identified_only",
  });
  started = true;
}

export function capture(event: string, props?: Record<string, unknown>): void {
  if (started) posthog.capture(event, props);
}

export function pageview(): void {
  if (started) posthog.capture("$pageview");
}
